import { useState, useEffect } from 'react';
import { remoteConfig, fetchAndActivate, getValue } from '../firebase';

export const useAdsConfig = () => {
  const [adsEnabled, setAdsEnabled] = useState(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);
        const isEnabled = getValue(remoteConfig, 'ads_enabled_web').asBoolean();
        setAdsEnabled(isEnabled);
      } catch (err) {
        console.error("Failed to fetch ads_enabled_web config", err);
      }
    };
    fetchConfig();
  }, []);

  return adsEnabled;
};
